import Images from "./images";

const trophies = [
    {  
        id: 1, 
        image: Images.award1,
        title: 'Champion League',
        year: 2000,
    },
    { 
        id: 2, 
        image: Images.award2,
        title: 'National League',
        year: 2004,
    },
    { 
        id: 3, 
        image: Images.award3,
        title: 'Premier League',
        year: 2008,
    },
    { 
        id: 4, 
        image: Images.award4,
        title: 'National Cup',
        year: 2012,
    },
    { 
        id: 5, 
        image: Images.award5,
        title: 'Champion League',
        year: 2016,
    },
    { 
        id: 6, 
        image: Images.award6,
        title: 'Premier League',
        year: 2020,
    },
 
];

export default trophies;